/**
 * CRM two-way sync DTO types.
 *
 * API/UI contract shapes only (admin mapping editors, dedupe review,
 * backfill progress, rep-facing source badges). Backend sync internals
 * (queue jobs, provider clients, reconciler state) are NOT modeled here.
 *
 * All DTO fields are camelCase.
 */
// =============================================================================
// Primitives
// =============================================================================
export const CrmProvider = {
    SALESFORCE: 'salesforce',
    HUBSPOT: 'hubspot',
};
export const CrmObjectType = {
    CLIENT: 'client',
    DEAL: 'deal',
    CONTACT: 'contact',
};
// =============================================================================
// Explicit-enable sync gating
// =============================================================================
/**
 * Integration-level sync direction: 'both' = bidirectional (default),
 * 'inbound' = pull from CRM only, 'outbound' = push to CRM only.
 */
export const CrmSyncDirection = {
    BOTH: 'both',
    INBOUND: 'inbound',
    OUTBOUND: 'outbound',
};
/** Revont close outcome that a closed external stage maps to. */
export const CrmCloseOutcome = {
    WON: 'won',
    LOST: 'lost',
};
// =============================================================================
// Record browsing + selective sync
// =============================================================================
/** Whether an external CRM record is currently synced to Revont. */
export const CrmRecordSyncState = {
    NOT_SYNCED: 'not_synced',
    SYNCING: 'syncing',
    PAUSED: 'paused',
};
/** Status filter for the browse-records query. */
export const CrmRecordStatusFilter = {
    ALL: 'all',
    NOT_SYNCED: 'not_synced',
    SYNCING: 'syncing',
    PAUSED: 'paused',
};
/**
 * Lifecycle status of an external link. Mirrors the backend repository enum.
 * `local_deleted` means the local Revont entity was deleted; the link row is
 * kept (with its external id) so inbound re-import of that external record stays
 * blocked - the anti-resurrection guard. See crm-inbound-service.
 */
export const CrmLinkStatus = {
    ACTIVE: 'active',
    CONFLICT: 'conflict',
    DELETED_REMOTE: 'deleted_remote',
    ERROR: 'error',
    LOCAL_DELETED: 'local_deleted',
};
